// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yetki-native-table {
  border-collapse: collapse;
  /* İçerik kadar: aramada az sütun kalınca boşluk pozisyon sütununa yayılmasın */
  width: auto;
  font-size: 12px;
}

.yetki-native-table tbody td:first-child,
.yetki-native-table thead th:first-child {
  white-space: nowrap;
}

.yetki-native-table thead th {
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  padding: 8px 4px;
  text-align: center;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 8;
}

.yetki-native-table.dark thead th {
  background-color: #1f1f1f;
  border-color: #434343;
}

.yetki-native-table tbody td {
  border: 1px solid #d9d9d9;
  padding: 4px;
  text-align: center;
  position: relative;
}

.yetki-native-table.dark tbody td {
  border-color: #434343;
}

.yetki-native-table tbody tr:hover {
  background-color: #d3ff4c !important;
  cursor: pointer;
}

.yetki-native-table.dark tbody tr:hover {
  background-color: #3a4a1c !important;
}

/* Satır vurgusu hücrelerde de: yapışkan pozisyon hücresinin satır içi arka planı (#fff) tr
   arka planını örtüyordu; içe gölge satır içi arka planın üstüne boyanır. */
.yetki-native-table tbody tr:hover > td {
  box-shadow: inset 0 0 0 9999px rgba(211, 255, 76, 0.55);
}

.yetki-native-table.dark tbody tr:hover > td {
  box-shadow: inset 0 0 0 9999px rgba(90, 120, 30, 0.6);
}

.yetki-native-table tbody tr:hover > td:first-child .ant-typography {
  font-weight: 700;
}

/* Kutucuk ipucu: hangi pozisyon · yetki · okuma/yazma */
.yetki-ipucu {
  display: none;
  position: fixed;
  z-index: 1100;
  pointer-events: none;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
}

.yetki-native-table tbody td.column-hovered {
  background-color: #ffd38b !important;
  cursor: pointer;
}

.yetki-native-table.dark tbody td.column-hovered {
  background-color: #c5d3ab !important;
}

.yetki-native-table .ant-checkbox-wrapper {
  margin: 0;
}

.yetki-yonetim-page.dark .yetki-native-table thead th {
  background-color: #1f1f1f;
  border-color: #434343;
  color: #fff;
}

.yetki-yonetim-page.dark .yetki-native-table tbody td {
  border-color: #434343;
}`, "",{"version":3,"sources":["webpack://./src/components/yetki/YetkiYonetimPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,+EAA+E;EAC/E,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;4EAC4E;AAC5E;EACE,uDAAuD;AACzD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".yetki-native-table {\n  border-collapse: collapse;\n  /* İçerik kadar: aramada az sütun kalınca boşluk pozisyon sütununa yayılmasın */\n  width: auto;\n  font-size: 12px;\n}\n\n.yetki-native-table tbody td:first-child,\n.yetki-native-table thead th:first-child {\n  white-space: nowrap;\n}\n\n.yetki-native-table thead th {\n  background-color: #fafafa;\n  border: 1px solid #d9d9d9;\n  padding: 8px 4px;\n  text-align: center;\n  font-weight: 600;\n  position: sticky;\n  top: 0;\n  z-index: 8;\n}\n\n.yetki-native-table.dark thead th {\n  background-color: #1f1f1f;\n  border-color: #434343;\n}\n\n.yetki-native-table tbody td {\n  border: 1px solid #d9d9d9;\n  padding: 4px;\n  text-align: center;\n  position: relative;\n}\n\n.yetki-native-table.dark tbody td {\n  border-color: #434343;\n}\n\n.yetki-native-table tbody tr:hover {\n  background-color: #d3ff4c !important;\n  cursor: pointer;\n}\n\n.yetki-native-table.dark tbody tr:hover {\n  background-color: #3a4a1c !important;\n}\n\n/* Satır vurgusu hücrelerde de: yapışkan pozisyon hücresinin satır içi arka planı (#fff) tr\n   arka planını örtüyordu; içe gölge satır içi arka planın üstüne boyanır. */\n.yetki-native-table tbody tr:hover > td {\n  box-shadow: inset 0 0 0 9999px rgba(211, 255, 76, 0.55);\n}\n\n.yetki-native-table.dark tbody tr:hover > td {\n  box-shadow: inset 0 0 0 9999px rgba(90, 120, 30, 0.6);\n}\n\n.yetki-native-table tbody tr:hover > td:first-child .ant-typography {\n  font-weight: 700;\n}\n\n/* Kutucuk ipucu: hangi pozisyon · yetki · okuma/yazma */\n.yetki-ipucu {\n  display: none;\n  position: fixed;\n  z-index: 1100;\n  pointer-events: none;\n  padding: 4px 8px;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.85);\n  color: #fff;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.yetki-native-table tbody td.column-hovered {\n  background-color: #ffd38b !important;\n  cursor: pointer;\n}\n\n.yetki-native-table.dark tbody td.column-hovered {\n  background-color: #c5d3ab !important;\n}\n\n.yetki-native-table .ant-checkbox-wrapper {\n  margin: 0;\n}\n\n.yetki-yonetim-page.dark .yetki-native-table thead th {\n  background-color: #1f1f1f;\n  border-color: #434343;\n  color: #fff;\n}\n\n.yetki-yonetim-page.dark .yetki-native-table tbody td {\n  border-color: #434343;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
